import { useState } from "react";
import {
  SubscriptionDashboardHeader,
  SubscriptionSummarySection,
  SubscriptionGrowthSection,
  SubscriptionPlanChartsSection,
  SubscriptionPlanDetailsSection,
  getRevenueByPlan,
  getPlanDistribution,
} from "../../../components/reportDashboard/subscribtions/subcribtions";
import { useSubscriptionsReport } from "../../../hooks/useReportDashboard";
import { ErrorRetry } from "../../../components/common/ErrorRetry";
import { getDateRangeFromFilter } from "../../../utils/reportDashboard/reportDashboardUtils";
import { mapSubscriptionSummaryToKpis } from "../../../utils/subscriptionSummary";

export function Subscriptions() {
  const [timeRange, setTimeRange] = useState("monthly");
  const dateRange = getDateRangeFromFilter(timeRange);
  const {
    data: subscriptionReportsData,
    isLoading,
    isError,
    error,
    refetch,
  } = useSubscriptionsReport(dateRange);

  if (isError)
    return (
      <ErrorRetry
        message={error?.message || "Unexpected error"}
        onRetry={refetch}
      />
    );

  const revenueByPlan = getRevenueByPlan(subscriptionReportsData);
  const planDistribution = getPlanDistribution(subscriptionReportsData);
  const subscriptionSummaryCards = mapSubscriptionSummaryToKpis(
    subscriptionReportsData?.data?.subscriptionSummary,
  );
  const subscriberGrowthTrend =
    subscriptionReportsData?.data?.subscriberGrowthTrendAnnual || [];

  return (
    <div className="space-y-6">
      <SubscriptionDashboardHeader
        timeRange={timeRange}
        onTimeRangeChange={setTimeRange}
      />

      <SubscriptionSummarySection
        loading={isLoading}
        summaryCards={subscriptionSummaryCards}
      />

      <SubscriptionGrowthSection
        loading={isLoading}
        growthData={subscriberGrowthTrend}
      />

      <SubscriptionPlanChartsSection
        loading={isLoading}
        revenueByPlan={revenueByPlan}
        planDistribution={planDistribution}
      />

      <SubscriptionPlanDetailsSection
        loading={isLoading}
        subscriptionData={subscriptionReportsData?.data}
      />
    </div>
  );
}
